import React from 'react'
import {
    Flex,
    Button,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {useIntl, FormattedMessage} from 'react-intl'
import {useCurrentCustomer} from '../../hooks/use-current-customer'
import {useGetMainMenu} from '../../custom-api/hooks/use-get-main-menu'
import DrawerHeaderLinkItem from './drawer-header-link-item'
import {useGigya} from '../../context/gigya'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import {getMrtApiBasepath} from '../../ssr/helpers'
import {AuthHelpers, useAuthHelper, useCustomerType} from '@salesforce/commerce-sdk-react'
import {remCalc} from '../../theme/_utils'
import useCorporateLayout from '../../hooks/use-corporate-layout'

const DrawerHeaderLinks = ({categoriesData}) => {
    const styles = useMultiStyleConfig('BraunMenu', {})
    const drawerItem = styles?.drawerItem || {}
    const headerLinksStyles = styles?.headerLinksStyles || {}
    const {data: customer} = useCurrentCustomer()
    const {data: menuData} = useGetMainMenu('braun_')
    const headerLinks = menuData?.headerlinks ? menuData?.headerlinks?.[0]?.links : []
    const intl = useIntl()
    const {gigyaObject} = useGigya()
    const {isRegistered} = useCustomerType()
    const logout = useAuthHelper(AuthHelpers.Logout)
    const navigate = useNavigation()
    const {showCorporateLayout} = useCorporateLayout()

    const onSignoutClick = async () => {
        gigyaObject && gigyaObject.accounts && gigyaObject.accounts.logout()
        await logout.mutateAsync()
        const endpoint = origin + getMrtApiBasepath('/logout')
        await fetch(`${endpoint}`).then(() => {
            setTimeout(() => {
                navigate('/login')
            }, 500)
        })
    }

    const handleMyAccount = () => {
        navigate('/account')
    }

    const handleWishList = () => {
        navigate('/wishlist')
    }

    return (
        <Flex flexDir="column" w="100%">
            <Flex {...headerLinksStyles?.headerLinksContainer}>
                {customer?.firstName && (
                    <Flex {...headerLinksStyles?.greetingContainer}>
                        <Text {...drawerItem.itemText} {...headerLinksStyles?.greetingText}>
                            {intl.formatMessage({
                                defaultMessage: 'Greetings',
                                id: 'header.popover.text.greetings',
                            })}
                            {', '}
                            {customer?.firstName}
                        </Text>
                    </Flex>
                )}

                <Flex flexDir="column" gap="xsmall.base">
                    {isRegistered && (
                        <Flex {...headerLinksStyles?.myAccountSection}>
                            <Button
                                {...headerLinksStyles?.headerLinkItem}
                                onClick={handleMyAccount}
                            >
                                <Text>
                                    <FormattedMessage
                                        defaultMessage="My Account"
                                        id="header.popover.title.my_account"
                                    />
                                </Text>
                            </Button>
                        </Flex>
                    )}
                    {!showCorporateLayout && (
                        <Flex {...headerLinksStyles?.myAccountSection}>
                            <Button {...headerLinksStyles?.headerLinkItem} onClick={handleWishList}>
                                <Text>
                                    <FormattedMessage
                                        id="global.wishlist"
                                        defaultMessage="Wishlist"
                                    />
                                </Text>
                            </Button>
                        </Flex>
                    )}
                    {!showCorporateLayout &&
                        headerLinks?.length > 0 &&
                        headerLinks?.map((hl) => {
                            return (
                                <DrawerHeaderLinkItem
                                    key={`header-link-${hl?._metadata?.uid}`}
                                    headerLink={hl}
                                    categoryData={categoriesData}
                                />
                            )
                        })}
                </Flex>
            </Flex>
            {isRegistered && (
                <Flex w="100%" paddingTop="medium.lg" marginBottom={remCalc(80)}>
                    <Button
                        w="100%"
                        variant="primary"
                        border="1px solid #E6E6E6"
                        onClick={onSignoutClick}
                    >
                        <Text textStyle="body-medium" fontWeight="medium">
                            <FormattedMessage
                                id="account.logout_button.button.log_out"
                                defaultMessage="Log Out"
                            />
                        </Text>
                    </Button>
                </Flex>
            )}
        </Flex>
    )
}

DrawerHeaderLinks.propTypes = {
    setSelectedCategory: PropTypes.func,
    categoriesData: PropTypes.object,
}

export default DrawerHeaderLinks
